export function convertDescriptorsToMaskMap(fieldDescriptors) {
    return fieldDescriptors.reduce((acc, cur, i) => {
        acc[1 << i] = cur;
        return acc;
    }, {});
}
//# sourceMappingURL=convertDescriptorsToMaskMap.js.map